import { supabase } from '@/integrations/supabase/client';

export type InterviewSessionInvite = {
  id: string;
  token: string;
  status: string;
  expires_at: string | null;
  session_number: number | null;
  created?: boolean;
};

export async function createOrGetInterviewSession(applicationId: string, forceNew = false) {
  const { data, error } = await supabase.rpc('create_or_get_interview_session', {
    _application_id: applicationId,
    _force_new: forceNew,
  });

  if (error) throw error;
  const row = Array.isArray(data) ? data[0] : data;
  return (row ?? null) as InterviewSessionInvite | null;
}
